<nav class="navbar" *ngIf="user$ | async as user">
  <a href="" class="sidebar-toggler" (click)="toggleSidebar($event)">
    <i class="feather icon-menu"></i>
  </a>
  <div class="navbar-content">
    <ul class="navbar-nav">
      <li class="nav-item nav-profile" ngbDropdown>
        <a class="nav-link" ngbDropdownToggle id="profileDropdown">
          <img class="wd-30 ht-30 rounded-circle me-2" src="/assets/images/avatar-icon.png" alt="profile">
          <p style="display: inline; margin-left: 10px;">
            {{user?.name}} {{user?.surname}}
          </p>
        </a>
        <div ngbDropdownMenu class="px-0" aria-labelledby="profileDropdown">
          <div class="d-flex flex-column align-items-center border-bottom px-5 py-3">
            <div class="mb-3">
              <img class="wd-80 ht-80 rounded-circle" src="/assets/images/avatar-icon.png" alt="">
            </div>
            <div class="text-center">
              <p class="tx-16 fw-bolder">{{user?.name}} {{user?.surname}} ({{user?.username}})</p>
              <p class="tx-14 fw-bolde">{{user?.deptName}}</p>
              <p class="tx-14 fw-bolde">{{user?.orgName}}</p>
              <!-- <p class="tx-12 text-muted">{{user?.username}}</p> -->
              <ng-container>
                <p *ngIf="user?.roleId === 1" class="text-muted mt-1 mb-3">ผู้ดูแลระบบ</p>
                <p *ngIf="user?.roleId === 2" class="text-muted mt-1 mb-3">สิทธิ์ระดับหน่วยงาน</p>
                <p *ngIf="user?.roleId === 3" class="text-muted mt-1 mb-3">สิทธิ์ระดับกลุ่มงาน</p>
              </ng-container>
            </div>
          </div>
          <ul class="list-unstyled p-1">
            <li class="dropdown-item py-2">
              <a href="https://member.chapanakit.rtp-eservice.com/" class="d-flex text-body ms-0">
                <i class="feather icon-home me-2 icon-md"></i>
                <span>หน้าหลัก</span>
              </a>
            </li>
          </ul>
        </div>
      </li>
    </ul>
  </div>
</nav>